import enUS1 from './locales/en-US';
import sv1   from './locales/sv';

export default {
  enUS:enUS1,
  svSE:sv1
};
